export const bizpotQuestionsHebrew: string[] = [
  'אני משיג את המטרות הכספיות שהצבתי עבור החברה שלי.',
  'יש לי הצלחה רבה באיתור ושכירת עובדים מיומנים.',
  'בתחום שלנו בשוק קיימת רק תחרות מעטה.',
  'אני נותן לצוות הגביה שלנו ציון 8 מתוך 10, או יותר.',
  'במושגים של מה שאנו מספקים ללקוחותינו אנו למעשה הטובים ביותר.',
  'אני מקיים ביקורת שוטפת על איכות המוצר/ השרות שלי.',
  'אנו משתמשים בסקרים כאשר אנו מחפשים עסקים חדשים.',
  'לעיתים קרובות אני מרגיש אשמה על כך שאיני מבלה יותר זמן עם משפחתי.',
  'על מנת לשמור על ערנותם של העובדים , על בעלי חברה ומנהלים לתת בונוסים בלתי צפויים במקום שיטה שגרתית של תשלום בונוסים.',
  'אני מאמין שניתן לעזור לאנשים.',
  'יש ירידה ברווחיות שלנו בשנים עשר החודשים האחרונים.',
  'עובדים לעיתים קרובות אינם מבינים כיצד העבודה שלהם משפיעה על אחרים בעבודה.',
  'הצרכים השוטפים של לקוחותינו מוגדרים היטב ומשמשים להגדלת נפח המכירות ללקוחותינו אלה.',
  'לקוחות מתלוננים לעיתים קרובות על טעויות בחשבונות שלהם.',
  'מה שאנו מספקים לקוחותינו הוא בדרך כלל בזמן, וטוב יותר ממה שציפו לו.',
  'אני משתמש בתלונות הלקוחות כאמצעי לשיפור העסק.',
  'אנו מקיימים רישום של לקוחות חדשים ויודעים מה מידת יעילות מאמצי השיווק שלנו.',
  'קיימות השפעות מחוץ לעסק שלי שדורשות את תשומת לבי כרגע.',
  'זה טבעי לגמרי שהעובדים וההנהלה לא יבטחו זה בזה.',
  'משהו חסר בחיים שלי.',
  'יש לנו בעיות תזרים מזומנים שצריך לפתור.',
  'עובדים חדשים בעסק שלי מקבלים הדרכה במהירות ותוך זמן קצר מתפקדים היטב במשרתם.',
  'חומרי הפרסום וקידום המכירות שלנו יוצרים ביעילות עסקאות חוזרות.',
  'אני תמיד צריך לחכות לדוחות גביה מעודכנים.',
  'אילו היה לי ציוד טוב יותר, יכולתי לייצר מוצר/שירות טוב יותר עבור לקוחותיי.',
  'הצוות שלי יודע שהוא טוב, איני צריך לשבח אותו.',
  'לנו תוכניות יעילות ומוכחות ליצירת מכירות חדשות.',
  'יש לחץ לא קטן בחיים שלי.',
  'לנסות להגדיר ולמדוד את התפוקה של כל עובד יהיה בזבוז זמן.',
  'ישנם דברים אחרים שאני חושב שעלי לעשות עם החברה שלי.',
  'החברה שלי הייתה מעורבת בהליכים משפטיים נגדה במהלך השנתיים האחרונות.',
  'לעיתים קרובות אני מוצא את עצמי פותר בעיות שעל אחרים (מנהלים או עובדים) לטפל בהם.',
  'אנו לא מוציאים באופן קבוע תקשורות ללקוחותינו הקבועים.',
  'לחברה שלנו יש מוניטין מצוין אצל מנהל הבנק.',
  'מחלקת המכירות שלנו מתלוננת לעיתים קרובות על האספקות של המוצר או השירות.',
  'לעסק שלי אין כל צורך ב"תכנית הבראה".',
  'החברה שלנו מקבלת חשיפה חיובית במאמרי עיתונים, פרסום חפשי וכו.',
  'לעיתים אני מודאג בקשר למצב הבריאות שלי.',
  'עבודת צוות מעכבת יצירתיות.',
  'ישנן כמה בעיות בעסק שלי שעבורם אין לי פתרונות.',
  'כמות החובות שיש לחברה שלי מהווה בעיה או פוטנציאל לבעיה.',
  'הייתי יכול לעשות הרבה יותר עבודה ביום אילו היו לי פחות הפרעות.',
  'אנו עושים/שולחים חומר קידום מכירות רק ללקוחותינו הקיימים.',
  'תשלום משכורות מתבצע תמיד בזמן.',
  'עדיין לא הדרכתי אף אחד כיצד לנהל ולטפל ביצור/שירות טוב כפי שאני עושה זאת.',
  'יש לנו ואנו משתמשים בתיבת הצעות ייעול של העובדים (או שיטה דומה).',
  'יש לי לפחות עובד אחד שתפקידו היחידי לפתח עסקים חדשים.',
  'יש יותר מדי תאונות / טעויות בחיים שלי.',
  'מדיניות טובה בעסקים תהיה לעגל כל פינה אפשרית כדי להגדיל את שולי הרווח.',
  'אני מתכוון למצוא דרך להיות יותר יעיל.',
  'רווחיות החברה שלי, בטווח הארוך נמצאת בעליה.',
  'תקשורות בתוך החברה שלי זורמות במהירות ובאופן חלק לאדם הנכון ללא אי הבנה.',
  'המכירה הממוצעת פר- לקוח נמצאת בעליה.',
  'אנו בדרך כלל מאחרים בתשלום המסים שלנו.',
  'איכות השירות נוטה להתמוטט כאשר אני מתרחק מהשטח לתקופת זמן ממושכת.',
  'מערכת הדרכת העובדים שלנו היא עניין שבשגרה.',
  'אנו לא מצפים לתגובות ממסע הפרסום שלנו.',
  'יש לי בעיה בריאותית אחת או יותר.',
  'רוב האנשים אינם רוצים לעבוד ועושים זאת רק מתוך צורך כלכלי.',
  'אני מחפש עזרה כדי לשפר מצבים.',
  'סך המכירות שלי גדל בשנתיים האחרונות.',
  'יש לי שיטת תגמול לעובדים העושים יותר מחלקם.',
  'אנו מפסידים עסקאות מכיוון שאין לנו מעקב פעילות הולם אחר לקוחותינו הקיימים.',
  'אני יכול להשיג את כל המסמכים הפיננסיים שלנו בהתראה קצרה.',
  'אנשי הייצור שלנו גאים ביצירת לקוחות מרוצים.',
  'יש לי כמה אנשים שמקבלים כרגע הדרכה כדי שיוכלו לתפוס עמדות בכירות מאלה שהם תופסים כרגע.',
  'יצירת עסקאות חדשות אינו חלק עיקרי מתחזיות המכירות שלנו.',
  'אחרים השפיעו עלי בביצוע החלטות שאחר כך התחרטתי עליהן.',
  'התרחבות אינה תמיד רצויה.',
  'יש משהו שעלי לשנות או שדברים יחמירו.',
  'קיים גורם חיצוני המהווה איום לקיומה של החברה שלי.',
  'אני תוהה לעיתים כמה באמת יצרניים הם העובדים שלי.',
  'יש לנו מאגר נתונים מלא לגבי הלקוחות שלנו בעבר ובהווה.',
  'הייתי רוצה לקבל את הדוחות הכספיים שלנו יותר מהר.',
  'לפעמים אני מתכווץ ורוצה להסתתר כאשר העובדים שלי מדברים ללקוחות.',
  'אנו מסתדרים היטב ללא הכשרה של עובדים.',
  'יחסי ציבור הם חלק עיקרי במאמצי השיווק שלנו.',
  'לעיתים אני חווה תקופות של דאגות ודיכאון.',
  'רוב הבעיות בין אנשים יכולות להיפתר בתקשורת.',
  'רוב הדברים המתיימרים לעזור לבני אדם גורמים למעשה ליותר נזק מטוב.',
  'החברה שלי תלויה במימון חיצוני נוסף (חובות או ערבויות) כדי להמשיך להתקיים.',
  'אני מנהל גרפים של כל הסטטיסטיקות החשובות של החברה שלי.',
  'יש לנו בסיס מתרחב של לקוחות מאד נאמנים.',
  'רשימת הנכסים הקבועים שלנו שלמה ומעודכנת.',
  'קיים תאום מצוין של כספים, אספקה, כוח אדם, לוגיסטיקה וכו בעסק שלי.',
  'אנו מיישמים עקרונות בקרת איכות על כל הארגון שלנו.',
  'אני מנהל רישומים נפרדים של עסקאות חדשות ושל עסקאות חוזרות.',
  'הסיפוק מהפעלת העסק שלי עולה בהרבה על הקשיים.',
  'מנהיג טוב לא יהסס להקריב אדם יחיד לטובת הקבוצה.',
  'אין שום דבר שמישהו אחר יוכל להגיד לי שיוכל לעזור לי לנהל טוב יותר את העסק שלי.',
  'מצב המזומנים של החברה שלי טוב יותר מאשר לפני שנה.',
  'באופן כללי, המורל בחברה שלי גבוהה מאוד.',
  '50% או יותר מהעסקים שלנו מגיעים מלקוח אחד.',
  'אני יודע לאן הכסף הולך לפני שמוציאים אותו.',
  'לו היינו עורכים סקר ללקוחותינו, לפחות 90% מהם היו אומרים שהם מרוצים ממה שאנו מספקים.',
  'יש לי סטטיסטיקה שמודדת את היעילות של בקרת האיכות שלנו.',
  'אנו מקבלים עסקאות חדשות מלקוחות קיימים המפנים אלינו.',
  'מישהו או משהו אחר אחראי למצב שהחברה שלי נמצאת בו.',
  'מנהל טוב יעדיף להרוויח כסף ולא ללוות אותו.',
  'אני תמיד מחפש דרכים לשפר את עצמי ואת החברה שלי.'
];

export const bizpotQuestionsEnglish: string[] = [
  'I achieve the financial goals I set for my company.',
            'I have had great success locating and hiring skilled workers.',
            'In our market, there is little competition.',
            'I give our collection team a grade of 8 out of 10, or more.',
            'In terms of what we provide to our customers we are actually the best.',
  'I conduct ongoing inspections of the quality of my product / service.',
            'We use surveys when we are looking for new businesses.',
            'I often feel guilty about not spending more time with my family.',
            'In order to keep employees vigilant, company owners and managers have to give unexpected bonuses instead of a routine method of paying bonuses.',
            'I believe people can be helped.',
            'There has been a decline in our profitability in the last twelve months.',
            'Employees often do not understand how their work affects others at work.',
            'Our customers current needs are well defined and are used to increase the volume of sales to these customers.',
            'Customers often complain about mistakes in their accounts.',
            'What we provide our customers is usually on time, and better than they expected.',
            'I use customer complaints as a means of improving my business.',
            'We are registering new customers and know how effective our marketing efforts are.',
            'There are influences outside of my business that require my attention right now.',
            'Its perfectly natural that the employees and the management do not trust each other.',
            'Something is missing in my life.',
            'We have cash flow problems that need to be solved.',
            'New employees in my business are being trained quickly and are soon functioning well.',
            'Our advertising and promotional materials effectively create repeat transactions.',
            'I always have to wait for updated collection reports.',
            'If I had better equipment, I could have produced a better product / service for my customers.',
            'My team knows its good, I do not have to praise it.',
            'We have effective and proven plans to generate new sales.',
            'Theres a lot of pressure in my life.',
            'Trying to set and measure the productivity of each employee will be a waste of time.',
            'There are other things I think I should do with my girlfriend.',
            'My company has been involved in legal proceedings against it over the past two years.',
            'I often find myself solving problems that others (managers or employees) have to deal with.',
            'We do not regularly communicate to our regular customers.',
            'Our company has an excellent reputation with the bank manager.',
            'Our sales department often complains about the deliveries of the product or service.',
            'My business has no need for a recovery plan. ',
            'Our company receives positive exposure in newspaper articles, free advertising, etc.',
            'Sometimes I worry about my health.',
            'Teamwork hinders creativity.',
            'There are some problems in my business for which I have no solutions.',
            'The amount of debt that my company has is a problem or potential for a problem.',
            'I could do a lot more work a day if I had less interruptions.',
            'We do / send promotional material only to our existing customers.',
            'Paying salaries is always done on time.',
            'I have not yet taught anyone how to manage and handle a good creature / service as I do.',
            'We have and we are using the Employees Optimization Box (or similar method).',
            'I have at least one employee whose only job is to develop new businesses.',
            'There are too many accidents / mistakes in my life.',
            'A good business policy will be to round up every possible corner to increase profit margins.',
            'Im going to find a way to be more efficient.',
            'My companys profitability, in the long run is rising.',
            'Communications within my company flow quickly and smoothly to the right person without misunderstanding.',
            'The average sale per customer is on the rise.',
            'We usually pay late for our taxes.',
            'The quality of service tends to collapse when I move away from the field for a long period of time.',
            'Our employee training system is routine. ',
            'We do not expect responses from our campaign.',
            'I have one or more health problems.',
            'Most people do not want to work and do so only out of financial need.',
            'Im looking for help to improve situations.',
            'My total sales have increased over the last two years.',
            'I have a reward system for workers who do more than their share.',
            'We are losing deals because we do not have a good track of our existing customers.',
            'I can get all our financial documents on short notice.',
            'Our production personnel are proud to create satisfied customers.',
            'I have a few people who are currently receiving training so that they can take senior positions from those they are currently occupying.',
            'Creating new transactions is not a major part of our sales forecasts.',
            'Others influenced me in making decisions that I later regretted.',
            'Expansion is not always desirable.',
            'Theres something I need to change or things will get worse.',
            'There is an external factor that threatens the existence of my company.',
            'I wonder sometimes how productive they really are.',
            'We have a complete database of our customers past and present.',
            'Id like to get our financial statements faster.',
            'Sometimes I shrink and want to hide when my employees talk to customers.',
            'We get along well without the training of workers.',
];
